import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Terminal, Zap } from "lucide-react";
import { NotificationBell } from "@/components/NotificationBell";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 h-14 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group">
          <div className="h-7 w-7 rounded-sm flex items-center justify-center bg-[var(--accent)]/10 border border-[var(--accent)]/40 group-hover:border-[var(--accent)] transition-colors">
            <Terminal size={14} className="text-[var(--accent)]" />
          </div>
          <span className="font-display font-bold tracking-tight text-white">
            MQL<span className="text-[var(--accent)]">4</span>Forge
          </span>
        </Link>

        {user ? (
          <nav className="flex items-center gap-6">
            <NavLink data-testid="nav-dashboard" to="/dashboard" end
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Strategies
            </NavLink>
            <NavLink data-testid="nav-builder" to="/builder"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Builder
            </NavLink>
            <NavLink data-testid="nav-ai" to="/ai"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              AI Generator
            </NavLink>
            <NavLink data-testid="nav-clone" to="/clone"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Clone
            </NavLink>
            <NavLink data-testid="nav-broker" to="/broker"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Broker
            </NavLink>
            <NavLink data-testid="nav-deployments" to="/deployments"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Live
            </NavLink>
            <NavLink data-testid="nav-journal" to="/journal"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Journal
            </NavLink>
            <NavLink data-testid="nav-gallery" to="/gallery"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Gallery
            </NavLink>
            <NavLink data-testid="nav-companion" to="/companion"
              className={({isActive}) => `tab-underline ${isActive ? "active" : ""}`}>
              Forge
            </NavLink>
            {user.pro_active ? (
              <span className="chip chip-accent" data-testid="nav-pro-badge">◆ PRO</span>
            ) : (
              <NavLink data-testid="nav-pro-link" to="/pro"
                className={({isActive}) => `tab-underline ${isActive ? "active" : ""} !text-[var(--accent)]`}>
                <Zap size={12} className="inline mr-1"/> Pro
              </NavLink>
            )}
            <div className="flex items-center gap-3 pl-6 border-l border-white/10">
              <NotificationBell/>
              <span className="text-xs font-mono text-[var(--text-secondary)] max-w-[160px] truncate" data-testid="nav-user-email">
                {user.email}
              </span>
              <button data-testid="nav-logout-btn" onClick={handleLogout}
                className="p-1.5 rounded border border-white/10 hover:border-[var(--loss)]/60 hover:text-[var(--loss)] transition-colors">
                <LogOut size={14} />
              </button>
            </div>
          </nav>
        ) : (
          <nav className="flex items-center gap-3">
            <Link data-testid="nav-gallery-public" to="/gallery" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors">Gallery</Link>
            <Link data-testid="nav-login-link" to="/login" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors">Log in</Link>
            <Link data-testid="nav-signup-link" to="/signup" className="btn-primary text-sm">
              Start building
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}
